






































































































import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator'
import ChatMenu from '@/components/Chat/ChatMenu.vue'
import {ChatStatus, ChatTemplate, ChatWorkflow} from '@/entities/chat'
import {getQuestionClass} from '@/domain/NPS'
import {addWatcher, deleteWatcher, toggleCaseClosed} from '@/api/chat'
import {Action, Getter} from 'vuex-class'
import Dropdown from '@/components/Dropdown.vue'
import {timeSince} from '@/utils/time'
import ChatForwardingLocked from '@/components/Chat/ChatForwardingLocked.vue'

@Component<ChatSidebar>({
    components: {
        Dropdown,
        ChatMenu,
        ChatForwardingLocked
    }
})
export default class ChatSidebar extends Vue {
    @Prop(String) public name!: string
    @Prop(String) public email!: string
    @Prop(Object) public customData!: {
        answer, case_closed, id, case_closed_option, user_id, watching, chat_forwarding_locked, is_suspected_bot
    }
    @Prop(Object) public chatStatus!: ChatStatus
    @Prop(Array) public caseOptions!: object[]
    @Prop(Object) public templates!: { [templateId: number]: ChatTemplate }
    @Prop(Object) public workflows!: { [workflowId: number]: ChatWorkflow }
    @Prop(Function) public onSelectTemplate // callback when select template
    @Prop(Function) public onSelectWorkflow // callback when select workflow
    @Prop(Boolean) public canReply !: boolean
    @Prop(Boolean) public showWorkflow !: boolean
    @Prop(String) public questionType !: string
    @Prop(String) public personId !: string
    @Prop(Number) public responseCount !: number

    @Action public loadChatCustomData

    public loadingCaseClosed = false
    public timeSince = timeSince

    public get isFiveScore() {
        return this.questionType && this.questionType !== 'nps'
    }

    public get loaded() {
        return Object.keys(this.customData).length > 0
    }

    public get selectedOption() {
        return this.customData.case_closed_option
    }

    public get circleClass() {
        const type = (this.isFiveScore) ? '5star' : 'nps'
        return this.customData && this.customData.answer &&
            getQuestionClass(this.customData.answer, type) || ''
    }

    public get caseIsClosed() {
        if (this.customData.case_closed === undefined ||
            this.customData.case_closed === null) {
            return 'default' // null means closed
        }
        return Number(this.customData.case_closed)
    }

    public get isSuspectedBot() {
        if (this.customData.is_suspected_bot) {
            return this.customData.is_suspected_bot
        }
        return false
    }

    public async toggleCaseClosed(isClosed, option) {
        if (this.loadingCaseClosed) {
            return
        }
        this.loadingCaseClosed = true
        this.updateToggleCase(isClosed, option)
        if (this.$refs.dropdown) {
            (this.$refs.dropdown as any).$data.opened = false
        }
    }

    public async updateToggleCase(isClosed, option) {
        await toggleCaseClosed(this.customData.id, isClosed, option)
        await this.loadChatCustomData()
        this.loadingCaseClosed = false
    }

    public async onUpdateWatcher(e) {
        if (e.target.checked) {
            // add watcher
            await addWatcher(this.customData.id, this.customData.user_id)
            await this.loadChatCustomData()
        } else {
            // delete watcher
            await deleteWatcher(this.customData.id)
            await this.loadChatCustomData()
        }
    }
}
